<template>
    <div class="pb-3">
        <p v-if="empty">
            {{ $t('elearning.no-elearning') }}
        </p>
        <ul class="list-group list-group-flush list" v-else>
            <li class="list-group-item px-0"
                v-for="(item, index) in items" :key="index"
            >
                <div class="row">
                    <div class="col-sm-9">
                        <h4 class="mb-0 font-weight-normal">
                            {{ item.activity_name }}
                        </h4>
                    </div>
                    <div class="col-sm-3 text-right">
                        <badge type="success" v-if="hasStatus">
                            {{ status(item) }}
                        </badge>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {  

        props: {

            registration: {
                type: Object,
            },

            learner: {
                type: Object,
            },
        },

        data() {
            return {
                items: [],
                loaded: false,
            }
        },

        created() {
            this.load()
        },

        computed: {

            empty() {
                return this.items.length == 0
            },
        },

        methods: {
            load() {
                axios.get('/astral/api/front/dashboard/registrations/'+this.registration.id+'/learners/'+this.learner.id+'/elearning')
                .then(resp => {
                    this.items = resp.data.data
                    this.loaded = true
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            },

            status(item) {
                if (item.score_raw !== null) {
                    return parseInt(item.score_raw) + '/' + parseInt(item.score_max)
                }
                if (item.completion) {
                    return this.$t('elearning.done')
                }
                return ''
            },

            hasStatus(item) {
                if (item.score_raw !== null) {
                    return true
                }
                if (item.completion) {
                    return true
                }
                return false
            }
        }
    }
</script>

